import type { RegisteredComponent } from "@builder.io/sdk-react";

/**
 * Builder inputs for `PartnerForm`. Nothing is required: dropped onto a page
 * as-is, the block is the complete form with the ticket's copy. Copy fields
 * have NO `defaultValue` — blank means "the built-in string", so a later copy
 * fix in code reaches every page that never overrode it. Fields, labels and
 * validation copy are not inputs: the field set is the partnerships email's
 * contract with `PartnerForm-Submit`.
 */
export const partnerFormInputs = [
  {
    name: "theme",
    friendlyName: "Background",
    type: "text",
    enum: [
      { label: "Dark card (white message text)", value: "dark" },
      { label: "Light background", value: "light" },
    ],
    defaultValue: "dark",
    helperText:
      "What the form sits on. The live page puts it on a navy card, so the success / error line is white.",
  },
  {
    name: "submitLabel",
    friendlyName: "Button label",
    type: "text",
    helperText: 'Empty: "Contact Our Team".',
  },
  {
    name: "successMessage",
    type: "text",
    helperText:
      'Shown under the button after a send; the form then stays locked until a reload. Empty: "Thanks for submitting a request! A member of our partnerships team will be in touch soon."',
  },
  {
    name: "failureMessage",
    type: "text",
    helperText:
      'Shown when a send fails; the entries are kept. Empty: "We couldn\'t send your request just now. Please try again."',
  },
  {
    name: "editorState",
    friendlyName: "Editor preview state",
    type: "text",
    enum: [
      { label: "Empty form", value: "ready" },
      { label: "Submitted with blank fields (errors)", value: "errors" },
      { label: "Sending", value: "submitting" },
      { label: "After a successful send (locked)", value: "success" },
      { label: "After a failed send", value: "failure" },
    ],
    defaultValue: "ready",
    advanced: true,
    helperText:
      "Only affects the Visual Editor and previews — nothing is ever sent from them. Live pages always behave normally.",
  },
] satisfies NonNullable<RegisteredComponent["inputs"]>;
